import AssistantCopilotMessagesAPI from 'dashboard/api/assistant/copilotMessages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AssistantCopilotMessage',
  API: AssistantCopilotMessagesAPI,
  getters: {
    getMessagesByThreadId: state => copilotThreadId => {
      return state.records
        .filter(record => record.copilot_thread_id === Number(copilotThreadId))
        .sort((a, b) => a.id - b.id);
    },
  },
  actions: mutationTypes => ({
    upsert({ commit }, data) {
      commit(mutationTypes.UPSERT, data);
    },
  }),
});
